<template>
  <div>
    <div>
      <div class="lg:mb-4 flex mx-2 flex-col lg:flex-row items-start lg:items-center justify-between">
        <div class="flex flex-row items-center">
          <div class="px-2  mt-4  mb-2 lg:mb-0 ">
            <span class="dark:bg-darkblue-800 dark:text-darkblue-200 font-bold  mr-4 text-ellipsis group-hover:text-primary">{{ label }}</span>
          </div>
          <div class="px-2  mt-4 mb-2 lg:mb-0">
            <span class='dark:bg-darkblue-800 dark:text-darkblue-200 badge badge-warning right-0 z-20 badge-count dark:hover:bg-darkblue-900 active:bg-primary-200'>
              {{ total }}
            </span>
          </div>
        </div>
        <div class="px-2 mt-4 mb-2 lg:mb-0">
            <base-table-pagination-mini
              :total='totalPage'
              :currentPage='currentPage'
              @changeCurrentPage='changeCurrentPage'
            ></base-table-pagination-mini>
        </div>
        <!-- <div class="flex flex-row w-100">
          <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
          <base-table-search @toggleFilters="toggleFilters" />
        </div> -->
      </div>
    </div>
    <el-table
      ref="tableErrors"
      :data="tableData"
      style="width: 100% "
      :cell-style="{padding: '0px !important', height: '40px'}"
      max-height="350"
      row-key="idCola"
      @sort-change="onSortChange"
      @filter-change="onFilterChange"
      lazy
      :load="load"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      show-deader=false>
      <el-table-column
        prop="empresa"
        label="Empresa"
        min-width="130"
        header-align="center"
        sortable="custom"
        show-overflow-tooltip
        filter-placement="bottom-start"
        column-key="empresas"
        :filters="dataFilterEmpresas"
        :filter-method="filterHandler"
        >
      </el-table-column>
      <el-table-column
        prop="sede"
        label="Sede"
        min-width="130"
        header-align="center"
        sortable="custom"
        show-overflow-tooltip
        filter-placement="bottom-start"
        column-key="sedes"
        :filters="dataFilterSedes"
        :filter-method="filterHandler"
        >
      </el-table-column>
      <el-table-column
        prop="error"
        label="Descripción del error"
        min-width="200"
        header-align="center"
        sortable="custom"
        show-overflow-tooltip
        >
      </el-table-column>
      <el-table-column
        prop="fecha"
        label="Fecha"
        width="150"
        header-align="center"
        sortable="custom"
        show-overflow-tooltip
        >
      </el-table-column>
      <el-table-column
        prop="icon"
        label="-"
        align="center"
        width="55">
        <template slot-scope="scope">
          <div v-if="isHistorico(scope.row)">
              <base-button-icon 
                @click="downloadHistorico(scope.row)"
                :name="iconHistorico"
                class="text-secondary dark:text-darkblue-200 cursor-pointer hover:text-primary dark:hover:text-primary"
                size="xs"
                ariaLabel="Descargar excel con histórico completo de errores"
              />
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getHistoricErrors } from '@/services/errors/getHistoricErrors'
import { getHistoricErrorsExcel } from '@/services/errors/getHistoricErrorsExcel'
import moment from 'moment'

import { getLocations } from '@/services/app/getLocations'
import { getSedesByEmpresa } from '@/services/app/getSedesByEmpresa'
import { getAllCompanies } from '@/services/companies/getAllCompanies'

export default {
  name: 'errors-table',
  props: {
    label: {
      type: String,
      default: 'Errores detectados en vigilancias'
    },
    tableData: {
      type: [Array, Object]
    },
    total: {
      type: Number,
      default: 0
    },
    icon: {
      type: String,
      default: ''
    },
    iconHistorico: {
      type: String,
      default: 'filetime'
    },
    totalPage: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    ascendingOrder: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      actualSort: null,
      isLoadedExcel: true,
      dataFilterEmpresas: [],
      dataFilterSedes: [],
      actualFilterEmpresas: [],
      actualFilterSedes: [],
      contFilter: 1,
      valueExcluded: -1000,
      tooltipVisible: false,
    }
  },
  watch: {
    actualFilterEmpresas () {
      this.sendChange()
    },
    actualFilterSedes () {
      this.sendChange()
    }
  },
  mounted: async function () {
    this.getEmpresasDefault()
    this.getSedesDefault()
  },
  computed: {
    role () {
      return this.$store.getters['auth/role']
    },
    isSA: function () {
      return (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador')
    },
    selectedClientDashboard () {
      return this.$store.getters['dashboard/getSelectedClient']
    },
    isSelectedClientDashboard () {
      return this.selectedClientDashboard !== undefined && this.selectedClientDashboard !== null && this.selectedClientDashboard !== 0
    },
  },
  methods: {
    getEmpresasDefault: async function () {
      let empresas = []
      this.dataFilterEmpresas = []
      if (this.isSA && !this.isSelectedClientDashboard) {
        // empresas = await getAllCompanies()
        this.dataFilterEmpresas.push({ text: 'Es necesario seleccionar un cliente en el Dashboard para utilizar este filtro', value: this.valueExcluded })
      } else {
        empresas = await getAllCompanies({ idEmpresaCert: this.selectedClientDashboard })
        if (empresas.blnError === true) {
          this.doFeedback(empresas.msgError + ' [Código de error: ' + empresas.codError + ']')
        }
        empresas.CIFSEmpresa.forEach(x => {
          this.dataFilterEmpresas.push({ text: x.CIF + ' - ' + x.NombreCIF, value: x.IdCIFEmpresa })
        })
      }
    },
    getSedesDefault: async function () {
      let locs = []
      this.dataFilterSedes = []
      if (this.isSA && !this.isSelectedClientDashboard) {
        locs = await getLocations()
      } else {
        locs = await getSedesByEmpresa({ idCliente: this.selectedClientDashboard })
      }
      if (locs.blnError === true) {
        this.doFeedback(locs.msgError + ' [Código de error: ' + locs.codError + ']')
      }
      locs.PGNS.forEach(x => {
        this.dataFilterSedes.push({ text: x.Nombre, value: x.IdPGN })
      })
    },
    onFilterChange (filters) {
      if (filters.sedes !== null) this.actualFilterSedes = filters.sedes
      if (filters.empresas !== null) {
        const empresasFilter = filters.empresas
        if (!empresasFilter) this.actualFilterEmpresas = empresasFilter
        else this.actualFilterEmpresas = empresasFilter.filter(x => x !== this.valueExcluded)
      }
    },
    filterHandler (value, row, column) {
      return true
      // const property = column.property
      // return row[property] === value
    },
    getActualSortFilters () {
      const data = {
        idCIFEmpresas: this.actualFilterEmpresas,
        idPGNs: this.actualFilterSedes,
        order: this.actualSort,
      }
      return data
    },
    load: async function (tree, treeNode, resolve) {
      try {
        const params = { idPGN: tree.idPGN, idCifEmpresa: tree.idCIFEmpresa }
        const response = await getHistoricErrors(params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          resolve([])
        } else {
          const finalData = []
          let cont = 1
          response.ListaEmpresasError.forEach(x => {
            const empresaValue = this.isSA && !this.isSelectedClientDashboard ? x.Cif.NombreCliente + ' - ' + x.Cif.Cif + ' - ' + x.Cif.Nombre : x.Cif.Cif + ' - ' + x.Cif.Nombre
            const obj = {
              idCola: 'H-' + cont + '-' + tree.idCola,
              idCIFEmpresa: x.Cif.idCifEmpresa,
              empresa: empresaValue,
              idPGN: x.Sede.idPgn,
              sede: x.Sede.Nombre,
              error: x.Error,
              fecha: this.formatDate(x.Fecha),
            }
            finalData.push(obj)
            cont++
          })
          resolve(finalData)
        }
      } catch (error) {
        this.doFeedback()
      } 
    },
    downloadHistorico: async function (row) {
      this.isLoadedExcel = false
      try {
        const params = { idPGN: row.idPGN, idCifEmpresa: row.idCIFEmpresa }
        const response = await getHistoricErrorsExcel(params) 
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'error-historico.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.isLoadedExcel = true
      }
    },
    isHistorico (row) {
      if (isNaN(row.idCola)) return false
      return true
    },
    formatDate: function (strDate) {
      return moment(strDate).format('DD-MM-yyyy HH:mm')
    },
    showHistorico (index) {
      alert(this.tableData[index].idCola + ' - ' + this.tableData[index].idCIFEmpresa + ' - ' + this.tableData[index].idPGN)
    },
    formatter: function (row, column) {
      return row.value
    },
    changeCurrentPage: async function (numPage) {
      this.$emit('changeCurrentPage', numPage)
      this.sendChange()
    },
    onSortChange: async function (sortProps) {
      const sort = { [sortProps.prop]: sortProps.order === 'ascending' }
      this.actualSort = sort
      this.sendChange()
    },
    sendChange: async function () {
      const data = this.getActualSortFilters()
      this.$emit('getData', data)
      // console.log(this.$refs.tableErrors)
    }
  }
}
</script>

<style scoped>
/deep/ .el-table tr td {
  padding: 0px 0 !important;
}

/deep/ .el-table td.is-left, .el-table th.is-left {
    text-align: left;
    justify-content: left;
}

/deep/ .el-table td.is-center, .el-table th.is-center {
    text-align: center;
    justify-content: center;
}

/deep/ .el-table td.is-right, .el-table th.is-right {
    text-align: right;
    justify-content: right;
}

/* /deep/ .el-table tr td div.cell {
    min-height: 40px !important;
    height: 40px !important;
    display: flex;
    align-items: center;
    justify-content: inherit;
} */

</style>
